export default theme => ({
  root: {
    paddingBottom: 5,
    '& + div': {
      display: 'none'
    }
  }
});